module.exports = __webpack_public_path__ + "static/media/test4_2.0ee54ade.png";